import { useState } from "react";
import { Card, CardBody, Table, TabPane } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { IoCreateOutline } from "react-icons/io5";
import { BsTrash3 } from "react-icons/bs";
import IconButton from "../../../../../components/Buttons/IconButton";
import CreateLeadSourceModal from "../Modals/CreateLeadSource";
import ConfirmationModal from "../../../../../components/Modals/Confirmation";
import { del } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function LeadSourcesTab({ leadSources, refreshSettings }) {
  const { t } = useTranslation();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [sourceToDelete, setSourceToDelete] = useState(null);
  const [sourceToEdit, setSourceToEdit] = useState(null);

  const deleteLeadSource = async () => {
    const data = await del(`/crm/settings/lead-sources/delete/${sourceToDelete}`);
    if(data?.success) {
      refreshSettings();
      setSourceToDelete(null);
      toast.success(t('crm.settings.lead_sources.deleted'));
    }
  }

  return(
    <TabPane tabId="lead-sources">
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted small fw-semibold text-uppercase mb-0">
              { t('crm.settings.lead_sources.title') }
            </p>
            <DefaultButton
              color="primary"
              size="sm"
              onClick={() => {
                setSourceToEdit(null);
                setCreateModalOpen(true);
              }}
            >
              + { t('common.create') }
            </DefaultButton>
          </div>

          <Table hover responsive className="mb-0">
            <thead className="table-light">
              <tr>
                <th>{ t('common.name') }</th>
                <th>{ t('timeline.createdBy') }</th>
                <th>{ t('common.actions') }</th>
              </tr>
            </thead>
            <tbody>
              {leadSources?.map((data, key) => (
                <tr key={key}>
                  <td>{ data.name }</td>
                  <td>{ data.created_by?.firstname + ' ' + data.created_by?.lastname }</td>
                  <td>
                    <div className="d-flex align-items-center gap-2 h-100">
                      <IconButton
                        size="sm" 
                        outline 
                        color="secondary"
                        onClick={() => {
                          setSourceToEdit(data);
                          setCreateModalOpen(true);
                        }}
                      >
                        <IoCreateOutline />
                      </IconButton>
                      <IconButton
                        size="sm" 
                        outline 
                        color="danger"
                        onClick={() => setSourceToDelete(data.id)}
                      >
                        <BsTrash3 />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <CreateLeadSourceModal 
        isOpen={createModalOpen}
        toggle={() => setCreateModalOpen(false)}
        refreshSettings={refreshSettings}
        sourceToEdit={sourceToEdit}
      />

      <ConfirmationModal
        isOpen={sourceToDelete !== null}
        title={t('crm.settings.lead_sources.deleteTitle')}
        message={t('crm.settings.lead_sources.deleteMessage')}
        onConfirm={deleteLeadSource}
        toggle={() => setSourceToDelete(null)}
      />
    </TabPane>
  );
}

export default LeadSourcesTab;